import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  color?: string;
  variant?: 'solid' | 'subtle';
}

export function Badge({ children, color = 'var(--color-accent)', variant = 'subtle' }: BadgeProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--space-1)',
        padding: 'var(--space-1) var(--space-3)',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--text-xs)',
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        background: variant === 'solid' ? color : `color-mix(in oklch, ${color} 15%, transparent)`,
        color: variant === 'solid' ? 'var(--color-text-on-accent)' : color,
      }}
    >
      {children}
    </span>
  );
}
